export default "__VITE_ASSET__2c9f842f__"